<script lang="ts">
	export let value: string | null;
</script>

{value || ""}
